var linkUrl;
//opening a link related code is platform dependent.
//this method will open link by checking its platform and widget type 
export const webLinkOpener = (url, widgetType) => {
  let browserCount = 0, callCount = 0;
  let browsers = [
    {
      browserName: "safari",
      packageName: 'com.apple.mobilesafari',
      url: url,
      uri: 'safari://'
    }
  ]
  linkUrl = url;
  widgetType = widgetType.toLowerCase().trim();
  //
  if (widgetType === "url renderer" ||widgetType === "html renderer") {
    console.log("url renderer")
    if (window.device) {
      //platform is browser
      if (window.device.platform === "browser") {
        window.open(url, "_blank");
      } else if (window.device.platform === "iOS") {
        //iOS platform 
        //com.google.chrome.ios 
        window.plugins.launcher.canLaunch(
          { uri: 'googlechrome://' },
          (data) => {
            callCount++;
            browsers.push({
              browserName: "chrome",
              packageName: 'com.google.chrome.ios',
              url: url,
              uri: 'googlechrome://'
            });
            checkSuccessCallback(data, browsers, callCount);
          },
          (errMsg) => {
            callCount++;
            checkErrorCallback(errMsg, browsers, callCount)
          }
        );
        //org.mozilla.firefox
        window.plugins.launcher.canLaunch(
          { uri: 'firefox://' },
          (data) => {
            callCount++;
            browsers.push({
              browserName: "firefox",
              packageName: 'org.mozilla.firefox',
              url: url,
              uri: 'firefox://'
            });
            checkSuccessCallback(data, browsers, callCount);
          },
          (errMsg) => {
            callCount++;
            checkErrorCallback(errMsg, browsers, callCount)
          }
        );
      // Android platform
      } else if (window.device.platform === "Android") {
        console.log("cordova android");
        window.plugins.launcher.launch(
          {
            uri: `${url}`,
          },
          successCallback,
          errorCallback
        );
      }
    } else {
      console.log("url",url);
      window.open(url, "_blank");
    }
  } else if (widgetType === "custom browser") {
    if (window.device) {
      if (window.device.platform === "browser") {
        window.open(url, "_self");
      } else if (window.device.platform === "iOS") {
        window.cordova.InAppBrowser.open(url, '_blank');
      } else if (window.device.platform === "Android") {
        window.cordova.InAppBrowser.open(url, '_blank');
      }
    } else {
      window.open(url, "_self");
    }
  }

  if (browsers.length > 1) {
    return browsers;
  } else {
    return null;
  }
}

const checkSuccessCallback = (data, browsers, callCount) => {
  console.log("checkSuccessCallback get called", data);
  if (callCount === 2) {
    callbrowser(browsers);
  }
};

const checkErrorCallback = (errMsg, browsers, callCount) => {
  console.log("check error Callback get called", errMsg);
  if (callCount === 2) {
    callbrowser(browsers);
  }
}

const successCallback = (data) => {
  console.log("successCallback get called", data);
};

const errorCallback = (errMsg) => {
  console.log("error Callback get called", errMsg);
}

const callbrowser = (browsers) => {
  if (browsers.length > 1) {
    console.log("more than 1 browser");
  } else {
    console.log("1 browser");
    window.plugins.launcher.launch({
      uri: `${linkUrl}`,
    }, successCallback, errorCallback);
  }
}